import { Divider } from '@/components/Divider'
import styled from '@emotion/styled'
import TAUserFeedback from '@ta-interaktiv/react-user-feedback'
import * as React from 'react'
import { defineMessages } from 'react-intl'
import { Locale, sharingArticleId } from '../domain'
import { AppVariant } from '../domain/appVariant'
import { useEnv } from '../lib/env'

const Root = styled('div')`
  label: UserFeedback;

  display: grid;
  grid-template-columns: 1fr;
  row-gap: 20px;

  font-family: var(--font-sans-serif);
  font-weight: 400;
  font-size: 16px;
  line-height: 1.3;
  color: inherit;

  & .feedback-text {
    font-family: var(--font-sans-serif);
    font-weight: 400;
    font-size: 16px;
    line-height: 1.3;
    color: inherit;
  }

  & .ui.table {
    display: block;
  }
  & .ui.table tbody {
    display: block;
  }
  & .ui.table tbody tr {
    display: block;
    padding-top: 20px;
  }
  & .ui.table tbody tr td {
    display: block;

    font-family: var(--font-sans-serif);
    font-weight: 400;
    font-size: 16px;
    line-height: 1.3;
    color: inherit;

    padding: 0;

    &.single.line.right.aligned {
      text-align: left;
      padding: 0 0 10px;

      & a {
        display: flex;
        padding-top: 10px;
        font-size: 1.3em;

        & .ui.icons {
          margin-right: 10px;
        }

        & .label {
          display: none;
        }
      }
    }
  }

  & i.star.icon {
    color: var(--text-color) !important;
  }

  & .ui.vertical.very.fitted.center.aligned.basic.segment {
    padding-bottom: 0;
  }

  & .ui.table {
    color: inherit;
  }

  & .ui.button {
    background-color: var(--button-background) !important;
    color: var(--site-background) !important;
  }
`

export const messageDescriptors = defineMessages({
  question1: {
    id: 'components.user-feedback.question1',
    defaultMessage: 'Wie nützlich ist die Abstimmungszentrale?',
  },
  question2: {
    id: 'components.user-feedback.question2',
    defaultMessage: 'Funktionierte die technische Umsetzung?',
  },
})

export const UserFeedback = ({ locale, appVariant = 'ballot' }: { locale: Locale; appVariant?: AppVariant }) => {
  const { intl } = useEnv()

  return (
    <Root>
      <Divider variant="strong" />

      <TAUserFeedback
        className={'infographic'}
        articleId={sharingArticleId[appVariant]![locale]}
        locale={locale}
        questions={[intl.formatMessage(messageDescriptors.question1), intl.formatMessage(messageDescriptors.question2)]}
      />

      <Divider />
    </Root>
  )
}
